"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceError = exports.ConfigurationError = void 0;
class ServiceError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, ServiceError.prototype);
    }
    static fromRequest(req, res) {
        let message = `Service error - ${req.method} ${req.url} failed`;
        if (res) {
            message += ` with status: ${res.status} ${res.statusText}`;
        }
        const e = new ServiceError(message);
        e.req = req;
        e.res = res;
        return e;
    }
}
exports.ServiceError = ServiceError;
class ConfigurationError extends Error {
    constructor(message = '') {
        message = `Configuration error: ${message}`;
        super(message);
        Object.setPrototypeOf(this, ConfigurationError.prototype);
    }
}
exports.ConfigurationError = ConfigurationError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWwvZXJyb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVdBLE1BQU0sWUFBYSxTQUFRLEtBQUs7SUFlOUIsWUFBWSxPQUFPO1FBQ2pCLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNmLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUN0RCxDQUFDO0lBZEQsTUFBTSxDQUFDLFdBQVcsQ0FBQyxHQUFpQixFQUFFLEdBQWM7UUFDbEQsSUFBSSxPQUFPLEdBQUcsbUJBQW1CLEdBQUcsQ0FBQyxNQUFNLElBQUksR0FBRyxDQUFDLEdBQUcsU0FBUyxDQUFDO1FBQ2hFLElBQUksR0FBRyxFQUFFO1lBQ1AsT0FBTyxJQUFJLGlCQUFpQixHQUFHLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBQyxVQUFVLEVBQUUsQ0FBQztTQUM1RDtRQUNELE1BQU0sQ0FBQyxHQUFHLElBQUksWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQ3BDLENBQUMsQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO1FBQ1osQ0FBQyxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUM7UUFDWixPQUFPLENBQUMsQ0FBQztJQUNYLENBQUM7Q0FNRjtBQVU0QixvQ0FBWTtBQVJ6QyxNQUFNLGtCQUFtQixTQUFRLEtBQUs7SUFDcEMsWUFBWSxPQUFPLEdBQUcsRUFBRTtRQUN0QixPQUFPLEdBQUcsd0JBQXdCLE9BQU8sRUFBRSxDQUFDO1FBQzVDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNmLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLGtCQUFrQixDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQzVELENBQUM7Q0FDRjtBQUVRLGdEQUFrQiJ9